import React, { useState, useEffect,ChangeEvent } from 'react';
import { DropdownMenu } from '../DropdownMenu';
import { DeclareCsiDivision } from "../../../utilities/DeclareCsiDivision";

interface CsiDivisionProps {
    options: DeclareCsiDivision[],
    selectedMainDivision?: string,
    selectedSubdivision?: string,
    onOptionChange?: (value: string, secondValue :string) => void;
}

const CsiDivision: React.FC<CsiDivisionProps> = ({ options, selectedMainDivision, selectedSubdivision, onOptionChange }) => {
    const [mainDivisionValue, setMainDivisionValue] = useState(selectedMainDivision || '--');
    const [subdivisionValue, setSubdivisionValue] = useState(selectedSubdivision || '--');

    useEffect(() => {
        setSubdivisionValue(selectedSubdivision ?? "");
    }, []);

    useEffect(() => {
        if (onOptionChange) {
            onOptionChange(mainDivisionValue, subdivisionValue);
        }
    }, [subdivisionValue]);

    const handleMainDivisionChange = (newValue: string) => {
        setMainDivisionValue(newValue);
        const subDiv = options?.find((option) => option.name === newValue)?.subdivisions[0] ?? '';
        setSubdivisionValue(subDiv);

        if (onOptionChange) {
            onOptionChange(newValue, subdivisionValue);
        }
    };

    const handleSubdivisionChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const newValue = event.target.value;
        setSubdivisionValue(newValue);

        if (onOptionChange) {
            onOptionChange(mainDivisionValue, newValue);
        }
    };

    const mainSelectedOption = options?.find((option) => option.name === mainDivisionValue);

    return (
        <div>
            <DropdownMenu options={options.map(o => o.name)}
                id="mainDivisionDropdown"
                onOptionSelected={handleMainDivisionChange}
                getFriendlyNameForOptions={o => o}
                getUniqueValueForOption={o => o}
                preselectedOption={selectedMainDivision}></DropdownMenu>
            {mainSelectedOption && mainSelectedOption?.subdivisions.length != 0 && (
                <select className="form-control" onChange={handleSubdivisionChange} value={subdivisionValue}>
                    {mainSelectedOption.subdivisions.map((subdivision, key) => (
                        <option key={key} value={subdivision}  >
                            {subdivision}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};


export default CsiDivision;